module.exports = __webpack_public_path__ + "img/Cafaro.70a4ce34.jpeg";